import { render, staticRenderFns } from "./PacienteDatosGenerales.vue?vue&type=template&id=615575fd&"
import script from "./PacienteDatosGenerales.vue?vue&type=script&lang=js&"
export * from "./PacienteDatosGenerales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports